// Pure display logic for the redesigned Shippers table. Everything here is deterministic
// so it can be unit tested without mounting the table.

export const ROUTING_AUTO = 'AUTO';
export const ROUTING_SHOP = 'SHOP';
export const ROUTING_MARKETPLACE = 'MARKETPLACE';

const SHIPPER_TYPE_BY_MODE = {
    [ROUTING_AUTO]: 'AUTO_ASSIGN',
    [ROUTING_SHOP]: 'RATE_SHOP',
    [ROUTING_MARKETPLACE]: 'MARKETPLACE',
};

/**
 * The routing chip for a `shipper_type`; NULL and unknown values are Marketplace. There's one chip
 * per value, so if Marketplace ever loses its chip, shippers get stranded there.
 */
export const routingModeFor = (shipperType) =>
    Object.keys(SHIPPER_TYPE_BY_MODE).find((mode) => SHIPPER_TYPE_BY_MODE[mode] === shipperType) || ROUTING_MARKETPLACE;

/** The `shipper_type` a routing chip writes. Throws on an unknown mode rather than guessing one. */
export const shipperTypeForRouting = (mode) => {
    const shipperType = SHIPPER_TYPE_BY_MODE[mode];
    if (!shipperType) throw new Error(`Unknown routing mode: ${mode}`);
    return shipperType;
};

// "Riverstone Logistics" → "RL". Falls back to a single glyph so the avatar is never blank.
export const initialsFor = (name) => {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return '?';
    return words
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('');
};

// A shipper can be on several delivery profiles. The table cell is narrow, so it shows the
// first name and "+N" for the rest; `all` is the full list for the hover title.
export const profileSummaryFor = (assignment) => {
    const names = (assignment?.profileNames || []).filter(Boolean);
    if (!names.length) return null;
    return { first: names[0], more: names.length - 1, all: names.join(', ') };
};

export const pluralize = (count, singular, plural) => (count === 1 ? singular : plural || `${singular}s`);
